import React from 'react';
export function Footer() {
  return <footer className="bg-brand py-8 border-t-4 border-gold text-center px-4" data-id="element-100" data-mp="32wd2qgad7ltj">
      <div className="max-w-4xl mx-auto" data-id="element-101" data-mp="3gg10g6ubc3z8">
        <p className="text-cream/80 text-sm" data-id="element-102" data-mp="3gh3rqfvjs8fo">
          © {new Date().getFullYear()} Golf Instructor Ready — All rights reserved.
        </p>
      </div>
    </footer>;
}